import { z } from 'zod'

export type AttributesTab = {
  id: string
  title: string
}

export const attributesTabSchema = z.object({
  id: z.string(),
  title: z.string(),
}) satisfies z.ZodType<AttributesTab>

export type AttributesTabs = {
  children: Array<AttributesTab>
  default?: string
}

export const attributesTabsSchema = z.object({
  children: z.array(attributesTabSchema),
  default: z.string().optional(),
}) satisfies z.ZodType<AttributesTabs>
